<template>
    <div class="smiles-radio-buttons">
        <v-btn v-for="(icon, index) in icons" :key="index"
               density="comfortable"
               variant="text"
               :color="getColor(index)"
               @click="value = index + 1"
               :icon="icon" />
    </div>
</template>

<script>
    export default {
        props: {
            modelValue: Number
        },

        emits: ["update:modelValue"],

        data() {
            return {
                value: this.modelValue,
                icons: [
                    "mdi-emoticon-cry-outline",
                    "mdi-emoticon-sad-outline",
                    "mdi-emoticon-neutral-outline",
                    "mdi-emoticon-happy-outline",
                    "mdi-emoticon-excited-outline"
                ]
            };
        },

        watch: {
            value(newValue) {
                this.$emit("update:modelValue", newValue);
            }
        },

        methods: {
            getColor(index) {
                const number = Number.parseInt(index) + 1;

                if (this.value === number) {
                    return "primary";
                }

                if (this.value >= 1 && this.value <= 5) {
                    return "grey-lighten-1";
                }

                return "grey-darken-1";
            }
        }
    };
</script>

<style lang="scss">
    .smiles-radio-buttons {
    }
</style>